<div class="card-container">
  <div class="card-title-wrapper">
    <h1 class="c11n-text-xl-headline" data-cy="trust-info-card-title" [innerHTML]="title"></h1>
  </div>
  <div class="card-content-wrapper" data-cy="trust-info-card-content">
    <ng-content></ng-content>
  </div>
</div>
